import React, { useState, useEffect } from 'react';
import CreateFAB from './CreateFAB';

function CreateBottomBar() {

  return (
    <div>
      <div className="fixed bottom-0 left-0 w-full shadow-md py-2 z-30 bg-white/70">
        <div className="flex items-center justify-center px-6 space-x-2">

          <CreateFAB />
          <a
            className={`btn-primary py-3 px-3 md:px-5 rounded-lg`}
            href={`/demo`}
          >
              Preview
          </a>
        </div>
      </div>
    </div>
  );
}

export default CreateBottomBar;
